import React from 'react';
import { 
    Create, 
    SimpleForm, 
    TextInput, 
    BooleanInput,
    required 
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";

export const ProgramCreate = props => {
    return (
        <React.Fragment>
            <Create label="Create Program" {...props}>
                <SimpleForm toolbar={<FormToolbar {...props} />}>
                    <TextInput 
                        source="program_code" 
                        label='Program Code' 
                        fullWidth={true} 
                        validate={[required()]} 
                        helperText="Unique code for the program (e.g., COACHING, SIP, ANUPRITI)"
                    />
                    <TextInput 
                        source="program_name" 
                        label='Program Name' 
                        fullWidth={true} 
                        validate={[required()]} 
                    />
                    <TextInput 
                        source="description" 
                        label='Description' 
                        fullWidth={true} 
                        multiline 
                        rows={4}
                        helperText="Describe the program's purpose and features"
                    />
                    <BooleanInput 
                        source="is_active" 
                        label="Active" 
                        defaultValue={true}
                    />
                </SimpleForm>
            </Create>
        </React.Fragment>
    );
}
